const HEADER_HEIGHT = 70;

export { HEADER_HEIGHT };
